import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import LoadingScreen from "../../../components/LoadingScreen";

// const balanceLogs = Array.from({ length: 20 }).map((_, i) => ({
//   _id: `${i + 1}`,
//   amount: Math.floor(Math.random() * 300 + 50),
//   amount_type: i % 2 === 0 ? "credit" : "debit",
//   req_type: i % 3 === 0 ? "sms" : "mms",
//   createdAt: new Date(Date.now() - i * 86400000).toISOString(),
//   from: "+15556667777",
//   to: "+14445558888",
//   device_id: `device-${i + 1}`,
//   message: `Sample message content #${i + 1}`,
// }));

const ITEMS_PER_PAGE = 6;

const BalanceLogsPage = () => {
  const { locationId } = useParams();
  const AppServices = useAppServices();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [balanceLogs, setBalanceLogs] = useState([]);
  const [typeFilter, setTypeFilter] = useState("all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const { response } = await AppServices.message.get_balance_logs({
        query: `locationId=${locationId}`,
      });
      if (response) {
        setBalanceLogs(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch logs", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLogs();
  }, []);

  const handleResetFilters = () => {
    setTypeFilter("all");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
  };

  const filteredLogs = balanceLogs.filter((log) => {
    const createdAt = new Date(log.createdAt);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const matchesType = typeFilter === "all" || log.req_type === typeFilter;
    const matchesDate =
      (!from || createdAt >= from) && (!to || createdAt <= to);

    return matchesType && matchesDate;
  });

  const totalPages = Math.ceil(filteredLogs.length / ITEMS_PER_PAGE);
  const paginatedLogs = filteredLogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  if (loading) {
    return <LoadingScreen loadingText={"Loading logs..."} />;
  }
  return (
    <div className="container py-2">
      <div className="mb-4">
        <h2 className="fw-semibold mb-5">📊 Balance Logs</h2>

        {/* Filters */}
        <div className="row g-3 p-3 bg-white rounded shadow-sm align-items-end">
          <div className="col-md-3">
            <label className="form-label small">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label small">Type</label>
            <select
              className="form-select"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <option value="all">All Types</option>
              <option value="sms">SMS</option>
              <option value="mms">MMS</option>
            </select>
          </div>
          <div className="col-md-3 text-end">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={handleResetFilters}
            >
              Reset Filters
            </button>
          </div>
        </div>
      </div>

      {/* Log Cards */}
      <div className="row g-4">
        {paginatedLogs.length === 0 ? (
          <div className="text-center text-muted py-5">No logs found.</div>
        ) : (
          paginatedLogs.map((log) => (
            <div className="col-md-6 col-lg-4" key={log._id}>
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body d-flex flex-column justify-content-between h-100">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4 className="mb-0">
                      {log.amount_type === "credit" ? (
                        <span className="text-success">+${log.amount}</span>
                      ) : (
                        <span className="text-danger">-${log.amount}</span>
                      )}
                    </h4>
                    <span
                      className={`badge rounded-pill ${
                        log.req_type === "sms"
                          ? "bg-primary"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {log.req_type.toUpperCase()}
                    </span>
                  </div>

                  <div className="text-muted small mb-2">
                    {new Date(log.createdAt).toLocaleString()}
                  </div>

                  <div className="small text-secondary mb-2">
                    <div>
                      <strong>Charge Id:</strong> {log?.chargeId || "-"}
                    </div>
                    <div>
                      <strong>From:</strong> {log?.message_log_id?.from || "-"}
                    </div>
                    <div>
                      <strong>To:</strong> {log?.message_log_id?.to || "-"}
                    </div>
                    <div>
                      <strong>Device:</strong>{" "}
                      {log?.message_log_id?.deviceId || "-"}
                    </div>
                    <div>
                      <strong>Message:</strong>{" "}
                      <span className="text-dark">
                        {log?.message_log_id?.messageContent || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <nav className="mt-5">
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
              >
                &laquo;
              </button>
            </li>
            {Array.from({ length: totalPages }).map((_, index) => (
              <li
                key={index}
                className={`page-item ${
                  currentPage === index + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
              >
                &raquo;
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default BalanceLogsPage;
